export const LastMoveOrders = () => import("./LastMoveOrders.vue");
